import { FunctionComponent } from "react";
import { FilteredByFlightDatesMedia } from "../../../api/channelsApi";
import { MediaContentType, MediaType, mediaContentTypeOptions } from "../../../api/mediaApi";
import { addLeadingZero, formatDuration, renderMediaType } from "../../../services/common";
import { formatDate } from "../../../services/dateService";
import SvgSelector from "../../components/svgSelector/SvgSelector";
import hiveStackIMG from './../../images/icons/hivestack.jpg';

interface FilteredByFlightDatesTableProps {
    items: FilteredByFlightDatesMedia[];
    openMediaPreview: (mediaId: string) => void;
}

const FilteredByFlightDatesTable: FunctionComponent<FilteredByFlightDatesTableProps> = (props) => {
    const isAddedInLastTenDays = (addDate: string) => {
        const now = new Date();
        const tenDaysAgo = new Date(now);
        tenDaysAgo.setDate(now.getDate() - 10);
        const addedDate = new Date(addDate);
        const result = addedDate >= tenDaysAgo && addedDate <= now;
        return result;
    }

    const renderPreview = (item: FilteredByFlightDatesMedia) => {
        let result;
        switch(item.mediaType){
            case MediaType.Image:
            case MediaType.Video:
            case MediaType.Youtube:
            case MediaType.YoutubeLive:
                result = <img className="sortable__item-img" src={item.previewUrl} alt="" />;
                break;
            case MediaType.VastUrl:
                result = <SvgSelector title="url" />;
                break;
            case MediaType.WebPage:
                result = <SvgSelector title="webview" />;
                break;
            case MediaType.HiveStack:
                result = <img className="sortable__item-img" src={hiveStackIMG} alt="" />;
                break;
        }

        return result;
    }

    const renderContentType = (contentType: MediaContentType) => {
        let contentTypeOption = mediaContentTypeOptions.find(it => it.type === contentType);
        let result = contentTypeOption?.name ?? "";
        return result;
    }

    const renderRows = () => {
        let result = props.items.map((item, index) => {
            return <tr className={isAddedInLastTenDays(item.addDate) ? "recently-added-media" : ""} key={item.mediaId}>
                <td>{addLeadingZero(index + 1, 2)}</td>
                <td className="preview-cell" style={{cursor:'pointer'}} onClick={() => props.openMediaPreview(item.mediaId)}>
                    {renderPreview(item)}
                </td>
                <td className="media-name-cell">
                    <span style={{cursor:'pointer', textDecoration:'underline'}} onClick={() => props.openMediaPreview(item.mediaId)}>{item.mediaName}</span>
                </td>
                <td>{renderMediaType(item.mediaType)}</td>
                <td>{item.campaigns.map(campaign => <p key={campaign}>{campaign}</p>)}</td>
                <td>{renderContentType(item.contentType)}</td>
                <td>{formatDuration(item.durationMs).slice(0, -4)}</td>
                <td>{formatDate(item.addDate)}</td>
                <td className="fly-dates-cell">
                    {item.periods.map(period => <p key={`${period.startDate}-${period.endDate}`}>
                        {formatDate(period.startDate)} - {formatDate(period.endDate)}
                    </p>)}
                </td>
            </tr>
        });

        return result;
    }

    return <table className="new-alighned-table filtered-by-flight-dates-table">
        <colgroup>
            <col style={{width:"40px"}} />
            <col style={{width:"140px"}} />
            <col style={{width:"200px"}} />
            <col style={{width:"100px"}} />
            <col />
            <col style={{width:"140px"}} />
            <col style={{width:"90px"}} />
            <col style={{width:"110px"}} />
            <col style={{width:"240px"}} />
        </colgroup>
        <thead>
            <tr>
                <td></td>
                <td></td>
                <td>Name</td>
                <td>Type</td>
                <td>Campaigns</td>
                <td>Content Type</td>
                <td>Duration</td>
                <td>Add Date</td>
                <td>Flight Dates</td>
            </tr>
        </thead>
        <tbody>
            {renderRows()}
        </tbody>
    </table>;
}

export default FilteredByFlightDatesTable;
